// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
// import { useSelector } from "react-redux";
// import { FaAngleDown } from "react-icons/fa";

// const UserDropdown = ({ onLogout }) => {
//   const [showDropdown, setShowDropdown] = useState(false);

//   const toggleDropdown = () => setShowDropdown(!showDropdown);
//   const associateProfileDetails = useSelector(
//     (state) => state.assoProfileDetails.profileDetails,
//   );
//   return (
//     <ul className="navbar-nav navbar-nav-icons flex-row">
//       <li className="nav-item dropdown">
//         {/* Toggle button */}
//         {/* <a
//           className="nav-link lh-1 pe-0 white-space-nowrap"
//           style={{ color: "var(--nav-color)" }}
//           role="button"
//           onClick={toggleDropdown} // ✅ use state toggle instead of bootstrap
//           onMouseEnter={() => setShowDropdown(true)}
//         >
//           {associateProfileDetails?.solutation}{" "}
//           {associateProfileDetails?.fullName}{" "}
//           <div>
//             <strong className="text-bolder">
//               ({associateProfileDetails?.assoCode})
//             </strong>
//             <FaAngleDown />
//           </div>
//         </a> */}
//         <a
//           className="nav-link lh-1 pe-0 white-space-nowrap d-flex align-items-center gap-2"
//           style={{ color: "var(--nav-color)" }}
//           role="button"
//           onClick={toggleDropdown}
//           onMouseEnter={() => setShowDropdown(true)}
//         >
//           <div className="d-flex flex-column align-items-start">
//             <div className="d-flex align-items-center gap-1">
//               {/* The Blinking Dot */}
//               {associateProfileDetails && (
//                 <span className="online-indicator">
//                   <span className="blinking-dot"></span>
//                 </span>
//               )}

//               <span>
//                 {associateProfileDetails?.solutation}{" "}
//                 {associateProfileDetails?.fullName}
//               </span>
//             </div>

//             <div className="d-flex align-items-center gap-1">
//               <strong className="text-bolder small">
//                 ({associateProfileDetails?.assoCode})
//               </strong>
//               <FaAngleDown size={12} />
//             </div>
//           </div>
//         </a>
//         {/* Dropdown */}
//         {showDropdown && (
//           <div
//             onMouseLeave={() => setShowDropdown(false)}
//             className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border show"
//           >
//             <div className=" border-0 shadow-sm rounded-4 overflow-hidden">
//               {/* Profile Header */}
//               <div className="d-flex align-items-center justify-content-start  pt-4 pb-3 bg-light-subtle">
//                 {/* Avatar */}
//                 <div className="me-3">
//                   <PreviewImage
//                     style={{
//                       height: "56px",
//                       width: "56px",
//                       borderRadius: "4px",
//                       objectFit: "cover",
//                     }}
//                     imgwithUrl={associateProfileDetails?.profileImage}
//                   />
//                 </div>

//                 {/* Name + Role */}
//                 <div className="text-start">
//                   <div className="fw-semibold text-dark fs-8">
//                     {associateProfileDetails?.solutation}{" "}
//                     {associateProfileDetails?.fullName}{" "}
//                   </div>
//                   <div className="text-muted  mt-1">
//                     Associate ID:{" "}
//                     <span className="fw-semibold badge fs-9 bg-primary-subtle text-primary">
//                       # {associateProfileDetails?.assoCode}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//               {/* Divider */}
//               <hr className="my-0" />
//               {/* Navigation */}
//               <ul className=" list-group  rounded-0">
//                 <li className="list-group-item py-0">
//                   <Link
//                     onClick={toggleDropdown}
//                     to="/profile"
//                     className="nav-link   text-dark d-flex align-items-center gap-2"
//                   >
//                     <i className="bi ms-1 bi-person-fill text-secondary" />{" "}
//                     Profile
//                   </Link>
//                 </li>
//                 <li className="list-group-item py-0">
//                   <Link
//                     onClick={toggleDropdown}
//                     to="/changePassword"
//                     className="nav-link   text-dark d-flex align-items-center gap-2"
//                   >
//                     <i className="bi ms-1 bi-key-fill text-secondary" /> Change
//                     Password
//                   </Link>
//                 </li>
//                 {/* Logout */}
//                 <div className="border-top px-4 py-2 bg-light-subtle">
//                   <button
//                     className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center gap-2"
//                     onClick={onLogout}
//                   >
//                     <i className="bi bi-box-arrow-right" />
//                     Logout
//                   </button>
//                 </div>
//               </ul>
//             </div>
//           </div>
//         )}
//       </li>
//     </ul>
//   );
// };

// export default UserDropdown;

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
import { useSelector } from "react-redux";
import { FaAngleDown } from "react-icons/fa";
import SessionTimer from "../../../../CommonComponets/SessionTimer.jsx";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import useApiRequest from "../../../../Hooks/apiReq.js";

const UserDropdown = ({ onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const [loggedInTime, setLoggedInTime] = useState(
    sessionStorage.getItem("loggedInTime"),
  );
  const associateProfileDetails = useSelector(
    (state) => state.assoProfileDetails.profileDetails,
  );
  const navigate = useNavigate();
  const [SESSION_DURATION_MINS, setSESSION_DURATION_MINS] = useState(60);

  const handleSessionExpire = () => {
    // Note: DO NOT clear session storage here! Wait for their choice.

    // 5 minutes in milliseconds (5 * 60 * 1000)
    const timeoutMs = 300000;

    Swal.fire({
      title: "Session Expiring!",
      text: "Your session limit has been reached. Would you like to stay logged in?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, keep me logged in",
      cancelButtonText: "No, log me out",
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#ef4444",
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: timeoutMs, // <-- ADDED: Automatically closes after 5 mins
      timerProgressBar: true, // <-- ADDED: Shows a shrinking visual progress bar
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // --- 1. USER CHOSE TO CONTINUE ---
        const newLoginTime = new Date().toISOString();
        sessionStorage.setItem("loggedInTime", newLoginTime);
        setLoggedInTime(newLoginTime);
        sendApiRequest("POST", "/Auth/refresh-token", "", {
          onSuccess: (res) => {
            if (
              res?.data == null &&
              res?.message ===
                "You have reached maximum refresh limit (3 times per day). Please login again."
            ) {
              sessionStorage.clear();
              navigate("/login");
            }
            sessionStorage.setItem("loggedInUser", res?.data);
            toast.success(
              `Session extended for another ${SESSION_DURATION_MINS} minutes!`,
            );
          },
        });
      } else if (result.isDismissed) {
        // --- 2. USER CHOSE TO LOGOUT OR TIMER EXPIRED ---
        // This block now triggers if they click "No", OR if the 5-minute timer runs out.
        sessionStorage.clear();
        navigate("/login");
      }
    });
  };

  return (
    <ul
      onClick={toggleDropdown}
      onMouseEnter={() => setShowDropdown(true)}
      onMouseLeave={() => setShowDropdown(false)}
      className="navbar-nav py-1 navbar-nav-icons flex-row"
    >
      <li className="nav-item dropdown">
        {/* Toggle button */}
        {/* <a
          className="nav-link lh-1 pe-0 white-space-nowrap"
          style={{ color: "var(--nav-color)" }}
          role="button"
          onClick={toggleDropdown} // ✅ use state toggle instead of bootstrap
          onMouseEnter={() => setShowDropdown(true)}
        >
          {associateProfileDetails?.solutation}{" "}
          {associateProfileDetails?.fullName}{" "}
          <div>
            <strong className="text-bolder">
              ({associateProfileDetails?.assoCode})
            </strong>
            <FaAngleDown />
          </div>
        </a> */}
        <a
          className="nav-link lh-1 pe-0 white-space-nowrap d-flex align-items-center gap-2"
          style={{ color: "var(--nav-color)" }}
          role="button"
        >
          <div className="d-flex flex-column align-items-start">
            <div className="d-flex align-items-center gap-1">
              {/* The Blinking Dot */}
              {associateProfileDetails && (
                <span className="online-indicator">
                  <span className="blinking-dot"></span>
                </span>
              )}
              <span>
                {associateProfileDetails?.solutation}{" "}
                {associateProfileDetails?.fullName}
              </span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <SessionTimer
                loginTime={loggedInTime}
                onExpire={handleSessionExpire}
                SESSION_DURATION_MINS={SESSION_DURATION_MINS}
              />
              <strong className="text-bolder ">
                ({associateProfileDetails?.assoCode})
              </strong>
              <FaAngleDown size={12} />
            </div>
          </div>
        </a>
        {/* Dropdown */}
        {showDropdown && (
          <div className="">
            <div
              onMouseEnter={() => setShowDropdown(true)}
              className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border show"
            >
              <div className=" border-0 shadow-sm rounded-4 overflow-hidden">
                {/* Profile Header */}
                <div className="d-flex align-items-center justify-content-start  pt-4 pb-3 bg-light-subtle">
                  {/* Avatar */}
                  <div className="me-3">
                    <PreviewImage
                      style={{
                        height: "56px",
                        width: "56px",
                        borderRadius: "4px",
                        objectFit: "cover",
                      }}
                      imgwithUrl={associateProfileDetails?.profileImage}
                    />
                  </div>

                  {/* Name + Role */}
                  <div className="text-start">
                    <div className="fw-semibold text-dark fs-8">
                      {associateProfileDetails?.solutation}{" "}
                      {associateProfileDetails?.fullName}{" "}
                    </div>
                    <div className="text-muted  mt-1">
                      Associate ID:{" "}
                      <span className="fw-semibold badge fs-9 bg-primary-subtle text-primary">
                        # {associateProfileDetails?.assoCode}
                      </span>
                    </div>
                  </div>
                </div>
                {/* Divider */}
                <hr className="my-0" />
                {/* Navigation */}
                <ul className=" list-group  rounded-0">
                  <li className="list-group-item py-0">
                    <Link
                      onClick={toggleDropdown}
                      to="/profile"
                      className="nav-link   text-dark d-flex align-items-center gap-2"
                    >
                      <i className="bi ms-1 bi-person-fill text-secondary" />{" "}
                      Profile
                    </Link>
                  </li>
                  <li className="list-group-item py-0">
                    <Link
                      onClick={toggleDropdown}
                      to="/"
                      className="nav-link   text-dark d-flex align-items-center gap-2"
                    >
                      <i className="  uil-chart-pie ms-1 text-secondary"></i>{" "}
                      Dashboard
                    </Link>
                  </li>
                  <li className="list-group-item py-0">
                    <Link
                      onClick={toggleDropdown}
                      to="/changePassword"
                      className="nav-link   text-dark d-flex align-items-center gap-2"
                    >
                      <i className="bi ms-1 bi-key-fill text-secondary" />{" "}
                      Change Password
                    </Link>
                  </li>
                  {/* Logout */}
                  <div className="border-top px-4 py-2 bg-light-subtle">
                    <button
                      className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center gap-2"
                      onClick={onLogout}
                    >
                      <i className="bi bi-box-arrow-right" />
                      Logout
                    </button>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        )}
      </li>
    </ul>
  );
};

export default UserDropdown;
